/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.abusedesk.rpc.PublicContentCaseRpc
 */

export const getModerationStatusForEmailRpc = {
  serviceName: 'com.hubspot.abusedesk.rpc.PublicContentCaseRpc',
  rpcName: 'getModerationStatusForEmail',
  auth: 'app',
  fingerprint: 'Y26hZt_nGEwG0zTQa1IsZ5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getModerationStatusForWebpageRpc = {
  serviceName: 'com.hubspot.abusedesk.rpc.PublicContentCaseRpc',
  rpcName: 'getModerationStatusForWebpage',
  auth: 'app',
  fingerprint: 'Y26hZt_nGEwG0zTQa1IsZ5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getModerationStatusForFormRpc = {
  serviceName: 'com.hubspot.abusedesk.rpc.PublicContentCaseRpc',
  rpcName: 'getModerationStatusForForm',
  auth: 'app',
  fingerprint: 'Y26hZt_nGEwG0zTQa1IsZ5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBulkModerationStatusesForEmailRpc = {
  serviceName: 'com.hubspot.abusedesk.rpc.PublicContentCaseRpc',
  rpcName: 'getBulkModerationStatusesForEmail',
  auth: 'app',
  fingerprint: 'rRdKMyaCim40e4YOBfitPyVRQ1fKBQlR',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBulkModerationStatusesForWebpageRpc = {
  serviceName: 'com.hubspot.abusedesk.rpc.PublicContentCaseRpc',
  rpcName: 'getBulkModerationStatusesForWebpage',
  auth: 'app',
  fingerprint: 'rRdKMyaCim40e4YOBfitPyVRQ1fKBQlR',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBulkModerationStatusesForFormRpc = {
  serviceName: 'com.hubspot.abusedesk.rpc.PublicContentCaseRpc',
  rpcName: 'getBulkModerationStatusesForForm',
  auth: 'app',
  fingerprint: 'rRdKMyaCim40e4YOBfitPyVRQ1fKBQlR',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};